interface IssueTypeIconProps {
  name: string;
}

/**
 * Jira-style issue type glyphs drawn locally — Jira's own type avatars
 * require an authenticated Atlassian session, which portal users don't have.
 */
const TYPE_STYLES: Record<string, { bg: string; path: string }> = {
  bug: { bg: 'bg-red-500', path: 'M8 5.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z' },
  story: { bg: 'bg-green-500', path: 'M5 4h6v8l-3-2-3 2z' },
  epic: { bg: 'bg-purple-500', path: 'M9 3L5 9h3l-1 4 4-6H8z' },
  subtask: { bg: 'bg-sky-400', path: 'M5 5h4v4H5zM7 7h4v4H7z' },
  task: { bg: 'bg-blue-500', path: 'M4.5 8.2l2.3 2.3 4.7-4.8' },
};

function styleFor(name: string) {
  const n = name.toLowerCase().replace(/[^a-z]/g, '');
  if (n.includes('bug')) return TYPE_STYLES.bug;
  if (n.includes('story')) return TYPE_STYLES.story;
  if (n.includes('epic')) return TYPE_STYLES.epic;
  if (n.includes('subtask')) return TYPE_STYLES.subtask;
  return TYPE_STYLES.task;
}

export function IssueTypeIcon({ name }: IssueTypeIconProps) {
  const { bg, path } = styleFor(name);
  const isStroke = path === TYPE_STYLES.task.path;
  return (
    <span className={`inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-[3px] ${bg}`} title={name}>
      <svg viewBox="0 0 16 16" className="h-3 w-3" aria-hidden="true">
        {isStroke ? (
          <path d={path} fill="none" stroke="white" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" />
        ) : (
          <path d={path} fill="white" />
        )}
      </svg>
    </span>
  );
}
